type User = {
  surname?: string;
  middleName?: string;
  firstName?: string;
};

export function getUserFio(user?: User) {
  return `${user?.surname ?? ""} ${user?.firstName?.at(0) ?? ""}. ${user?.middleName?.at(0) ?? ""}`;
}
